import React from 'react';
import { Card, Col, Row, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Cards = props => {
    return (
        <Card className="mb-5 p-3 mb-5 rounded pointer shadow">
            <Link to={`${props.url}`} >
                <Row noGutters={true}>
                    <Col xs={4} lg={4} sm={4} md={4} xl={4}>
                        <Image src={props.icon} thumbnail />
                    </Col>
                    <Col xs={8} lg={8} sm={8} md={8} xl={8}>
                        <Card.Body>
                            <Card.Title>{props.title}</Card.Title>
                            <Card.Text>{props.text}</Card.Text>
                        </Card.Body>
                    </Col>                    
                </Row>
            </Link>
        </Card>
    );
}

export default Cards;